import { Close } from "@mui/icons-material";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
} from "@mui/material";
import { useRef } from "react";
import { useParams } from "react-router-dom";

import { useContractsQuery } from "AdvisoryManagement/Api/Queries/useContractsQuery";
import {
	DocumentSelectionTable,
	type DocumentSelectionTableRef,
} from "AdvisoryManagement/Components/Documents/DocumentSelectionTable";
import { ContractStatus } from "Infrastructure/Api/Api";

type PostWaybillProps = {
	handleClose: () => void;
};

export const PostWaybill = ({ handleClose }: PostWaybillProps) => {
	const { advisoryCaseId } = useParams<{ advisoryCaseId: string }>();

	const { data: contracts } = useContractsQuery(advisoryCaseId, [
		ContractStatus.InProgress,
	]);

	const tableRef = useRef<DocumentSelectionTableRef>(null);

	const documents =
		contracts?.items.flatMap(
			(c) =>
				c.documents?.map((d) => ({
					...d,
					documentType: d.documentType,
					categoryCode: c.categoryCode,
				})) || [],
		) || [];

	const handleConfirm = () => {
		tableRef.current?.submit();
	};

	return (
		<Dialog open={true} onClose={handleClose} fullWidth maxWidth="md">
			<DialogTitle>
				Vytvoření průvodky
				<IconButton
					aria-label="close"
					onClick={handleClose}
					sx={{
						position: "absolute",
						right: 16,
						top: 16,
						color: "#414651",
					}}
				>
					<Close />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<DocumentSelectionTable
					documents={documents}
					ref={tableRef}
					// defaultSelectedIds={[]}
					onConfirm={() => {}}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Zrušit</Button>
				<Button onClick={handleConfirm} variant="contained">
					Vytvořit průvodku
				</Button>
			</DialogActions>
		</Dialog>
	);
};
